import React from 'react';
import PageLoader from '../../../common/PageLoader';
import { applySort, SORT, useUserCoords } from '../../../../utils/sortListings';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  filterGarageListCategory,
  getGarageCategory,
  getGarageDataWFilter,
  getUserGarageFilterA2Z,
  getUserGarageFilterZ2A,
} from './../../../../Redux/Actions/UserAction';
import 'bootstrap/dist/css/bootstrap.css';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { useTranslation } from 'react-i18next';
import SortControl from '../../../common/SortControl';
import ServiceFilterPanel, {
  EMPTY_SERVICE_FILTER,
  isServiceFilterActive,
  serviceMatchesFilter,
  brandOptionsFromRows,
} from '../../../common/ServiceFilterPanel';

export default function UseGarages() {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const dispatch = useDispatch();
  const [filterList, setFilterList] = useState([]);
  const [filterOption, setFilterOption] = useState('');
  const [category, setCategory] = useState('');
  const [sortOption, setSortOption] = useState(SORT.DISTANCE); // [CF 2026-08-02] nearest-first by default
  // [CF 2026-08-02] Only asks the browser for a location when the user
  // actually picks the distance sort; cached for the session after that.
  const userCoords = useUserCoords(sortOption === SORT.DISTANCE);
  // [CF 2026-08-02] Service type / car brand / open-now, all matched in the
  // browser — the garage listing already returns services, their brands and
  // the opening calendar.
  const [svcFilter, setSvcFilter] = useState({ ...EMPTY_SERVICE_FILTER });
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    dispatch(getGarageDataWFilter());
    dispatch(getGarageCategory());
  }, [dispatch]);

  const garagefilterdata = useSelector((state) => state.home.GarageFilterList);
  const garageA2Z = useSelector((state) => state.home.userGarageA2Z);
  const garageZ2A = useSelector((state) => state.home.userGarageZ2A);
  const garageCategory = useSelector((state) => state.home.garageCategoryList);
  const filteredCategoryList = useSelector(
    (state) => state.home.filteredGarageList
  );
  const catFilter = filteredCategoryList?.data;

  const onHandleChange = (e) => {
    setCategory(e.target.value);
  };

  useEffect(() => {
    console.log('category', category);

    dispatch(filterGarageListCategory(category));
  }, [category, dispatch]);

  useEffect(() => {
    setFilterList(catFilter);
    if (category === 'default') {
      setFilterList(garagefilterdata);
    }
  }, [catFilter, category, garagefilterdata]);

  useEffect(() => {
    if (garagefilterdata !== undefined) {
      setFilterList(garagefilterdata);
    }
    if (filterOption === 'a2z') {
      setFilterList(garageA2Z?.data);
    } else if (filterOption === 'z2a') {
      setFilterList(garageZ2A?.data);
    }
  }, [filterOption, garagefilterdata, garageA2Z, garageZ2A]);

  const categories = garageCategory?.response;

  const visibleList = React.useMemo(() => {
    if (!filterList) return undefined;
    let list = [...filterList];
    const q = search.trim().toLowerCase();
    if (q) {
      list = list.filter((x) =>
        (x.garageName || '').toLowerCase().includes(q)
      );
    }
    list = list.filter((x) => serviceMatchesFilter(x, svcFilter));
    list = applySort(list, sortOption, {
      name: (x) => x.garageName,
      coords: userCoords,
    });
    return list;
  }, [filterList, sortOption, userCoords, search, svcFilter]);

  // Service options come from the category master (bilingual); brand options
  // are derived from the garages on screen so we never offer an empty result.
  const serviceOptions = React.useMemo(
    () =>
      (categories || [])
        .filter((c) => c?.category)
        .map((c) => ({
          value: c.category,
          label: isRTL ? c.category : c.categoryEn || c.category,
        })),
    [categories, isRTL]
  );
  const brandOptions = React.useMemo(
    () => brandOptionsFromRows(filterList, isRTL),
    [filterList, isRTL]
  );

  const [mapModalOpen, setMapModalOpen] = useState(false);

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  return (
    <div>
      <div
        class="modal modal-left fade"
        id="left_modal_sm"
        tabindex="-1"
        role="dialog"
        aria-labelledby="left_modal_sm"
      ></div>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-2">{t('Garages')}</h2>

          <div
            className="filter-row mb-4 d-flex align-items-center flex-nowrap"
            style={{ gap: '14px' }}
          >
            {/* Sort By — left */}
            <SortControl value={sortOption} onChange={setSortOption} />

            {/* [CF 2026-08-02] Filter funnel — panel opens on its own row below. */}
            <button
              type="button"
              onClick={() => setFiltersOpen((o) => !o)}
              aria-label={t('Filter')}
              title={t('Filter')}
              style={{
                width: '42px',
                height: '42px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                borderRadius: '50%',
                background: isServiceFilterActive(svcFilter) ? '#fff7e6' : 'transparent',
                cursor: 'pointer',
                flex: '0 0 auto',
              }}
            >
              <img
                src="assets/images/icons/filter.png"
                alt={t('Filter')}
                style={{ width: '22px', height: '22px' }}
              />
            </button>

            {/* Search (icon → expands) + result count — fills remaining space on the same row */}
            <div
              className="d-flex align-items-center"
              style={{
                gap: '12px',
                minWidth: 0,
                flex: '1 1 auto',
                justifyContent: 'flex-end',
              }}
            >
              {searchOpen ? (
                <div
                  style={{
                    position: 'relative',
                    flex: '1 1 auto',
                    maxWidth: '460px',
                    minWidth: 0,
                  }}
                >
                  <input
                    type="text"
                    autoFocus
                    className="form-control"
                    placeholder={t('Search by name')}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ paddingInlineEnd: '34px' }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setSearch('');
                      setSearchOpen(false);
                    }}
                    aria-label={t('Clear')}
                    style={{
                      position: 'absolute',
                      insetInlineEnd: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: '20px',
                      lineHeight: 1,
                      color: '#666',
                    }}
                  >
                    &times;
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setSearchOpen(true)}
                  aria-label={t('Search by name')}
                  style={{
                    width: '42px',
                    height: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: 'none',
                    borderRadius: '50%',
                    background: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  <img src="assets/images/icons/search.png" alt={t('Search by name')} style={{ width: '22px', height: '22px' }} />
                </button>
              )}
            </div>
          </div>

          {filtersOpen && (
            <ServiceFilterPanel
              value={svcFilter}
              onChange={setSvcFilter}
              onApply={() => setFiltersOpen(false)}
              fields={['service', 'brand', 'openNow']}
              serviceOptions={serviceOptions}
              brandOptions={brandOptions}
            />
          )}

          <div class="row">
            {visibleList !== undefined ? (
              visibleList?.map((x, i) => {
                const logo = x?.businessMedia?.find(
                  (media) => media?.mediaType === 'LOGO'
                )?.media?.path;

                //Location Data
                const gpsData = x?.gps;
                const lat = parseFloat((gpsData || {}).lat);
                const lng = parseFloat((gpsData || {}).long);

                return (
                  <>
                    <div
                      key={x?.garageOwnerId || i}
                      className="col-4 col-sm-4 col-md-4 col-lg-3 mb-4"
                    >
                      <div class="user-garage-block">
                        <Link to={`/user-garages-detail/${x.garageOwnerId}`}>
                          <div
                            style={{
                              width: '100%',
                              aspectRatio: '1 / 1',
                              overflow: 'hidden',
                              borderRadius: '50%',   // [CF] client: all logos rounded
                              background: '#f4f4f4',
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                              src={
                                logo ||
                                'assets/images/user/garages/garage-logo/garage.jpg'
                              }
                              alt={x?.garageName || ''}
                              loading="lazy"
                              decoding="async"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  'assets/images/user/garages/garage-logo/garage.jpg';
                              }}
                            />
                          </div>
                        </Link>
                        <div class="line-b">{x.garageName}</div>
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <>
                {/* <h2>dsdasdfasdf</h2> */}
                <div
                  className="text-center text-warning"
                  const
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  <PageLoader /> <br />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
